import styled from 'styled-components';
import { baseStyles, baseProps } from './base.style';
import { containerStyles, containerProps } from './container.style';
import { breakpointStyles, border, getPropTypes } from './utils';

export const LegacyListItemChild = styled.div<StyleProps>`
  ${baseStyles}
  ${containerStyles}
  ${breakpointStyles(baseStyles)}
  ${breakpointStyles(containerStyles)}
  ${breakpointStyles(border)}
`;

export const listProps = {
  ...baseProps,
  ...containerProps,
};

LegacyListItemChild.propTypes = getPropTypes(listProps);

LegacyListItemChild.defaultProps = {
  alignItems: 'center',
  flex: true,
  justifyContent: 'space-between',
  padding: {
    bottom: '24px',
    top: '24px',
  },
  width: '100%',
};
